/* global hljs */
'use strict';

var React = require('react/addons');
var cx = React.addons.classSet;

var CodeSnippet = React.createClass({
  displayName: 'CodeSnippet',

  propTypes: {
    language: React.PropTypes.string.isRequired,
    toggle: React.PropTypes.bool,
    visible: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      toggle: true,
      visible: false
    };
  },

  getInitialState: function getInitialState() {
    return {
      visible: this.props.visible || !this.props.toggle
    };
  },

  handleClick: function handleClick(event) {
    event.preventDefault();
    var value = !this.state.visible;

    var self = this;

    this.setState({
      visible: value
    }, function () {
      if (value) {
        var el = self.refs.codeBlock.getDOMNode();
        hljs.highlightBlock(el);
      }
    });
  },

  componentDidMount: function componentDidMount() {
    if (this.state.visible) {
      var el = this.refs.codeBlock.getDOMNode();
      hljs.highlightBlock(el);
    }
  },

  render: function render() {
    var arrowClasses = cx({
      'code-snippet__arrow': true,
      'code-snippet__arrow--right': !this.state.visible,
      'code-snippet__arrow--up': this.state.visible });

    return React.createElement(
      'div',
      { className: 'code-snippet' },
      this.props.toggle ? React.createElement(
        'a',
        { href: '#', onClick: this.handleClick, className: 'code-snippet__toggle-button' },
        React.createElement('span', { className: arrowClasses }),
        !this.state.visible ? 'Show code' : 'Hide code'
      ) : null,
      this.state.visible ? React.createElement(
        'pre',
        null,
        React.createElement(
          'code',
          { className: this.props.language, ref: 'codeBlock' },
          this.props.children
        )
      ) : null
    );
  }
});

module.exports = CodeSnippet;


/*****************
 ** WEBPACK FOOTER
 ** ./example/components/code-snippet.jsx
 ** module id = 6
 ** module chunks = 0
 **/